module.exports = __webpack_public_path__ + "img/compassion.b39b80e8.svg";